export default __webpack_public_path__ + "static/media/after_work_sample.83eede2b.png";